import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import PopUp from 'components/PopUp';
import { RouteTypes } from 'RouteTypes';
import { setBuyToDefault } from 'store/pack/packActions';
import { selectIsBuyingEnd, selectPackStatus } from 'store/pack/packSelectors';

import { PopUpText } from '../styled';

const PackPurchaseStatusPopup = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const buyStatus = useSelector(selectPackStatus);
  const isBuyEnd = useSelector(selectIsBuyingEnd);
  const [errorBuyMessage, setErrorBuyMessage] = useState(buyStatus === 'error');
  const [successBuyMessage, setSuccessBuyMessage] = useState(buyStatus === 'allowed');

  const hideErrorPopUp = () => {
    dispatch(setBuyToDefault());
    setErrorBuyMessage(false);
  };
  const hideSuccessPopUp = () => {
    dispatch(setBuyToDefault());
    setSuccessBuyMessage(false);
  };
  const goToPacks = () => {
    dispatch(setBuyToDefault());
    history.push(RouteTypes.Packs);
  };

  return (
    <>
      {errorBuyMessage && isBuyEnd && (
        <PopUp onHide={hideErrorPopUp}>
          <PopUpText>
            {t('collection.purchase.error')}
          </PopUpText>
          <Button onClick={hideErrorPopUp} background="black" width="100%">OK</Button>
        </PopUp>
      )}
      {successBuyMessage && isBuyEnd && (
        <PopUp onHide={hideSuccessPopUp}>
          <PopUpText>
            {t('collection.purchase.success')}
          </PopUpText>
          <PopUpText>
            {t('collection.purchase.successSubtitle')}
          </PopUpText>
          <Button
            margin="0 0 20px 0"
            width="100%"
            size="big"
            onClick={goToPacks}
          >
            {t('collection.purchase.goToPacks')}
          </Button>
          <Button
            onClick={hideSuccessPopUp}
            background="black"
            width="100%"
            size="big"
          >
            {t('common.close')}
          </Button>
        </PopUp>
      )}
    </>
  );
};

export default PackPurchaseStatusPopup;
